// risks.new.tsx
// Route : /risks/new — Saisir un risque globalement avec sélection de la région et du site.

import { createFileRoute } from "@tanstack/react-router";

import { useAuth } from "@/application/contexts/AuthContext";
import { usePermissions } from "@/application/hooks/usePermissions";
import { AppLayout } from "@/presentation/layouts/AppLayout";
import { RiskFormPage } from "@/presentation/pages/RiskFormPage";
import { UnauthorizedPage } from "@/presentation/pages/UnauthorizedPage";

export const Route = createFileRoute("/risks/new")({
  component: function QuickRiskComponent() {
    const { isLoading } = useAuth();
    const { duerp } = usePermissions();

    if (isLoading) {
      return null;
    }

    if (!duerp.canAccessQuickRiskEntry()) {
      return <UnauthorizedPage />;
    }

    return (
      <AppLayout>
        <RiskFormPage siteId="" isGlobalSelection={true} />
      </AppLayout>
    );
  },
});
